import { axios_instance } from "./index";

export async function create(data) {
  return axios_instance.post("tickets/", data)
}

export const ticketService = {
  create,
};
